import { render, staticRenderFns } from "./NewAjuste.vue?vue&type=template&id=6c221900&scoped=true"
import script from "./NewAjuste.vue?vue&type=script&lang=js"
export * from "./NewAjuste.vue?vue&type=script&lang=js"
import style0 from "./NewAjuste.vue?vue&type=style&index=0&id=6c221900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c221900",
  null
  
)

export default component.exports